import { REMOVER_FILTRO_PONTO_EMBARQUE } from '../types'

export default function removerFiltroPontoEmbarque (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_PONTO_EMBARQUE
  }
}
